import axiosInstance from "@/api/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  Lead,
  PROGRESS_BAR,
  Stage,
  IStageGroup,
} from "./services/KanbanService";
import {
  LocationData,
  ProjectClass,
  ProjectStatus,
  ProjectType,
} from "../filters/type";


type KANBAN = {
  stages: Stage[];
  leads: Lead[];
  lead_ids: number[];
  stage_group: IStageGroup[];
  progress_bar: Record<number | string, PROGRESS_BAR> | null;
  leadsColor: LEAD_COLOR[];
  isDropDisable: boolean;
  isDeleteStageDialogOpen: boolean;
  isMoveLeadsDialogOpen: boolean;
  currentStageId: number;
  currentStageName: string;
  updatedStageIDs: string[];
  updateProgressBar: boolean;
  itemsLimit: number;
  crmLocationFilters: {
    states: LocationData[];
    regions: LocationData[];
    counties: LocationData[];
    cities: LocationData[];
    isApplied: boolean;
  };
  crmTypeFilters: {
    statuses: ProjectStatus[];
    classes: ProjectClass[];
    types: ProjectType[];
    isApplied: boolean;
  };
  crmAssigneeFilters: {
    selectedItems: Record<string, number[]>;
    allSelected: Record<string, boolean>;
    isApplied: boolean;
  };
  groupByApplied: boolean;
  archivedApplied: boolean;
  favoriteApplied: boolean;
};

export type LEAD_COLOR = {
  id: number;
  name: string;
  hex: string;
};

const initialState: KANBAN = {
  stages: [],
  leads: [],
  lead_ids: [],
  stage_group: [],
  progress_bar: null,
  leadsColor: [],
  isDropDisable: false,
  isDeleteStageDialogOpen: false,
  isMoveLeadsDialogOpen: false,
  currentStageId: NaN,
  currentStageName: "",
  updatedStageIDs: [],
  updateProgressBar: false,
  itemsLimit: 10,
  crmLocationFilters: {
    states: [],
    regions: [],
    counties: [],
    cities: [],
    isApplied: false,
  },
  crmTypeFilters: {
    statuses: [],
    classes: [],
    types: [],
    isApplied: false,
  },
  crmAssigneeFilters: {
    selectedItems: {},
    allSelected: {},
    isApplied: false,
  },
  groupByApplied: false,
  archivedApplied: false,
  favoriteApplied: false,
};

export const getStages = createAsyncThunk("kanban/getStages", async () => {
  const response = await axiosInstance({
    method: "GET",
    url: "/api/v1/stages",
  });
  console.log("response", response);
  // setColumns(response.data.data.data.stages);
  return response.data.data.data.stages;
});

const kanbanSlice = createSlice({
  name: "kanban",
  initialState,
  reducers: {
    setStages: (state, action) => {
      state.stages = action.payload;
    },
    setStageGroup: (state, action) => {
      state.stage_group = action.payload;
    },
    setLeads: (state, action) => {
      state.leads = action.payload;
    },
    setLeadsColor: (state, action) => {
      state.leadsColor = action.payload;
    },
    setProgressBar: (state, action) => {
      state.progress_bar = action.payload;
    },
    setLeadIds: (state, action) => {
      state.lead_ids = action.payload;
    },
    setIsDropDisable: (state, action) => {
      state.isDropDisable = action.payload;
    },
    setIsDeleteStageDialogOpen: (state, action) => {
      state.isDeleteStageDialogOpen = action.payload;
    },
    setIsMoveLeadsDialogOpen: (state, action) => {
      state.isMoveLeadsDialogOpen = action.payload;
    },
    setCurrentStageId: (state, action) => {
      state.currentStageId = action.payload;
    },
    setCurrentStageName: (state, action) => {
      state.currentStageName = action.payload;
    },
    setUpdatedStageIDs: (state, action) => {
      // if (action.payload) {
      const temp = action.payload?.map((i: number | string) => String(i));
      state.updatedStageIDs = temp;
      // }
    },
    setUpdateProgressBar: (state, action) => {
      state.updateProgressBar = action.payload;
    },
    setItemsLimit: (state, action) => {
      state.itemsLimit = action.payload;
    },
    setCrmLocationFilters: (state, action) => {
      state.crmLocationFilters = action.payload;
    },
    setCrmTypeFilters: (state, action) => {
      state.crmTypeFilters = action.payload;
    },
    setCrmAssigneeFilters: (state, action) => {
      state.crmAssigneeFilters = action.payload;
    },
    setGroupByApplied: (state, action) => {
      state.groupByApplied = action.payload;
    },
    setArchivedApplied: (state, action) => {
      state.archivedApplied = action.payload;
    },
    setFavoritesApplied: (state, action) => {
      state.favoriteApplied = action.payload;
    }
  },
});

export const {
  setStages,
  setLeads,
  setProgressBar,
  setLeadIds,
  setStageGroup,
  setLeadsColor,
  setIsDropDisable,
  setIsDeleteStageDialogOpen,
  setIsMoveLeadsDialogOpen,
  setCurrentStageId,
  setCurrentStageName,
  setUpdatedStageIDs,
  setUpdateProgressBar,
  setItemsLimit,
  setCrmLocationFilters,
  setCrmTypeFilters,
  setCrmAssigneeFilters,
  setGroupByApplied,
  setArchivedApplied,
  setFavoritesApplied
} = kanbanSlice.actions;
export default kanbanSlice.reducer;
